export default __webpack_public_path__ + "static/media/grey-washed-wall.c3452b78.png";